import React, {useState, useEffect, useRef} from 'react';
import {
    EditorState,
    AtomicBlockUtils
} from 'draft-js';
import Dropdown from '../../../../bootstrap/components/dropdown/Dropdown';
import IframeForm from '../forms/iframe/IframeForm';

export default function useImage(editorState, setEditorState) {
    const [dialogShown, setDialogShown] = useState(false);

    const insertImageAtomicBlock = (iframe) => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'IFRAME',
            'IMMUTABLE',
            iframe
        );
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, {currentContent: contentStateWithEntity});

        setEditorState(AtomicBlockUtils.insertAtomicBlock(
            newEditorState,
            entityKey,
            iframe.title || ' '
        ));
    };

    const buttonRef = useRef(null);

    const iframeButton = <button
        type="button"
        ref={buttonRef}
        onMouseDown={ev => {
            ev.preventDefault();
            setDialogShown(true);
        }}
    >
        Iframe
    </button>;

    const iframeDialog = !dialogShown ? null
        : <Dropdown
            opener={buttonRef.current}
            close={() => setDialogShown(false)}
            horizontalAlignment="center"
            isPointerEnabled={true}
        >
            <IframeForm
                onDone={iframeInfo => {
                    insertImageAtomicBlock(iframeInfo);
                    setDialogShown(false);
                }}
                onCancel={() => setDialogShown(false)}
            />
        </Dropdown>;

    return [
        iframeButton,
        iframeDialog,
    ];
}
